import {
	ActionButton,
	Menu,
	MenuItem,
	MenuTrigger,
	Popover,
	Text,
} from '@react-spectrum/s2';
import Download from '@react-spectrum/s2/icons/Download';
import Image from '@react-spectrum/s2/icons/Image';
import Images from '@react-spectrum/s2/icons/Images';

import { useDownloadPostImages } from '@/spaces/content/useDownloadPostImages';

import { toolRailButtonClass } from './toolRail';

interface PostDownloadButtonProps {
	imageUrls: string[];
	artifactId: string;
	activeSlideIndex: number;
	onMenuOpenChange?: (isOpen: boolean) => void;
}

/**
 * Tool-rail download affordance for Instagram post artifacts. Single-image
 * posts download directly; carousels open a menu offering the current slide
 * or a zip of every slide.
 */
export const PostDownloadButton = ({
	imageUrls,
	artifactId,
	activeSlideIndex,
	onMenuOpenChange,
}: PostDownloadButtonProps) => {
	const { downloadCurrent, downloadAll } = useDownloadPostImages(
		imageUrls,
		artifactId,
		activeSlideIndex,
	);

	if (imageUrls.length <= 1) {
		return (
			<ActionButton
				aria-label="Download"
				onPress={downloadCurrent}
				UNSAFE_className={toolRailButtonClass}
			>
				<Download />
			</ActionButton>
		);
	}

	return (
		<MenuTrigger onOpenChange={onMenuOpenChange}>
			<ActionButton
				aria-label="Download"
				UNSAFE_className={toolRailButtonClass}
			>
				<Download />
			</ActionButton>
			<Popover>
				<Menu>
					<MenuItem id="current" onPress={downloadCurrent}>
						<Image />
						<Text>This image</Text>
					</MenuItem>
					<MenuItem id="all" onPress={downloadAll}>
						<Images />
						<Text>All {imageUrls.length} images in this series</Text>
					</MenuItem>
				</Menu>
			</Popover>
		</MenuTrigger>
	);
};
